'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fetchCatalogsIfNeeded = exports.getCatalogIdsForSeller = exports.getCatalog = exports.LOAD_CATALOGS_SUCCESS = exports.LOAD_CATALOGS_REQUEST = exports.LOAD_CATALOGS_FAIL = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _fetchBatch = require('../modules/fetchBatch');

var _api = require('../api');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _user = require('../modules/user');

var _config = require('../modules/config');

var _home = require('../modules/home');

var _item = require('../modules/item');

var _sellerEndedCatalogs = require('../modules/sellerEndedCatalogs');

var _sellerUpcomingCatalogs = require('../modules/sellerUpcomingCatalogs');

var _similarItems = require('../modules/similarItems');

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */
var LOAD_CATALOGS_FAIL = exports.LOAD_CATALOGS_FAIL = 'la/domain/catalogs/LOAD_FAIL';
var LOAD_CATALOGS_REQUEST = exports.LOAD_CATALOGS_REQUEST = 'la/domain/catalogs/LOAD_REQUEST';
var LOAD_CATALOGS_SUCCESS = exports.LOAD_CATALOGS_SUCCESS = 'la/domain/catalogs/LOAD_SUCCESS';

var REDUX_STORE_TIME = (0, _ms2.default)('30m');
var FETCH_SET_SIZE = 120;

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case LOAD_CATALOGS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.catalogIds)
            });
        case LOAD_CATALOGS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case LOAD_CATALOGS_SUCCESS:
        case _home.LOAD_HOME_DATA_SUCCESS:
        case _item.LOAD_ITEMS_SUCCESS:
        case _sellerUpcomingCatalogs.LOAD_SELLER_UPCOMING_CATALOGS_SUCCESS:
        case _sellerEndedCatalogs.LOAD_SELLER_ENDED_CATALOGS_SUCCESS:
        case _similarItems.LOAD_SIMILAR_ITEMS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.catalogs) {
                action.payload.catalogs.forEach(function (item) {
                    existing[item.catalogId] = (0, _extends3.default)({}, item);
                    loaded[item.catalogId] = time;
                    loading = (0, _difference2.default)(loading, [item.catalogId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.catalog;
};
var globalStateSelector = function globalStateSelector(state) {
    return state;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

var getCatalog = exports.getCatalog = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || {};
});

var getLoadTimeForCatalog = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

var isCatalogLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.includes(id);
});

var shouldFetchCatalog = (0, _reselect.createSelector)([getCatalog, getLoadTimeForCatalog, isCatalogLoading], function (catalog, loaded, loading) {
    if (catalog) {
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    return !loading;
});

var getCatalogIdsForSeller = exports.getCatalogIdsForSeller = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return (0, _keys2.default)(byId).map(function (key) {
        return byId[key];
    }).filter(function (catalog) {
        return catalog.sellerId === id && catalog.catalogStatus;
    }).map(function (catalog) {
        return catalog.catalogId;
    });
});

var whichCatalogsNeeded = (0, _reselect.createSelector)([globalStateSelector, idSelector], function (state, catalogIds) {
    return catalogIds.filter(function (catalogId) {
        return shouldFetchCatalog(state, catalogId);
    });
});

/* ACTION CREATORS */
var loadCatalogs = function loadCatalogs(catalogIds, loadingId, isFinalFetch) {
    return function () {
        var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(dispatch, getState) {
            var state, authToken, deployment, response;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            state = getState();
                            authToken = (0, _user.getAuthToken)(state);
                            deployment = (0, _config.getDeployment)(state);

                            dispatch({
                                payload: catalogIds,
                                type: LOAD_CATALOGS_REQUEST
                            });
                            _context.next = 7;
                            return _api.Catalog.fetchCatalogsByIds({ authToken: authToken, catalogIds: catalogIds, deployment: deployment });

                        case 7:
                            response = _context.sent;

                            dispatch({
                                meta: { actionTime: Date.now(), catalogIds: catalogIds },
                                payload: response.data,
                                type: LOAD_CATALOGS_SUCCESS
                            });
                            if (isFinalFetch) {
                                dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));
                            }
                            _context.next = 16;
                            break;

                        case 12:
                            _context.prev = 12;
                            _context.t0 = _context['catch'](0);

                            dispatch({
                                error: true,
                                meta: { catalogIds: catalogIds },
                                payload: _context.t0,
                                type: LOAD_CATALOGS_FAIL
                            });
                            dispatch((0, _fetchBatch.loadBatchEnd)(loadingId));

                        case 16:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, undefined, [[0, 12]]);
        }));

        return function (_x3, _x4) {
            return _ref.apply(this, arguments);
        };
    }();
};

var loadCatalogsInSets = function loadCatalogsInSets(ids, setSize, loadingId) {
    return function (dispatch) {
        if (ids.length > setSize) {
            return dispatch(loadCatalogs(ids.slice(0, setSize), loadingId, false)).then(function () {
                dispatch(loadCatalogsInSets(ids.slice(setSize), setSize, loadingId));
            });
        }
        return dispatch(loadCatalogs(ids, loadingId, true));
    };
};

var fetchCatalogsIfNeeded = exports.fetchCatalogsIfNeeded = function fetchCatalogsIfNeeded(catalogIds) {
    var loadingId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'none';

    return function (dispatch, getState) {
        var needed = whichCatalogsNeeded(getState(), catalogIds);
        if (needed.length) {
            dispatch((0, _fetchBatch.loadBatchStart)(loadingId));
            return dispatch(loadCatalogsInSets(needed, FETCH_SET_SIZE, loadingId));
        }
        return _promise2.default.resolve();
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/catalog.js
// module id = yv/Z
// module chunks = 46